import {TreeNodeNavigationEngineFactory} from './treeNodeNavigationEngine';
import {HistoryNodeNavigationEngineFactory} from './historyNodeNavigationEngine';
import {WizardFocusSerializer} from './wizardFocusSerializer.service';

export default angular.module('wizardNavigation', [])
    .service("treeNodeNavigationEngineFactory", TreeNodeNavigationEngineFactory)
    .service("historyNavigationEngineFactory", HistoryNodeNavigationEngineFactory)
    .service("wizardFocusSerializer", WizardFocusSerializer)
    .name;
